import { PropsWithChildren } from "react";
const DestinationRow = ({
  title,
  subtitle,
  children
}: PropsWithChildren<{
  title: string;
  subtitle: string;
}>) => {
  return <section className='destinationRowCTM py-[30px] md:pt-4' data-sentry-component="DestinationRow" data-sentry-source-file="DestinationRow.tsx">
      <div className='px-6 pb-4 md:px-[45px] md:pb-5'>
        <h2 className='text-center font-wasgaten text-2xl leading-[1em] tracking-[-0.02em] text-brand-dark md:text-[30px]'>
          {title}
        </h2>
        <p className='mt-2 text-center text-sm leading-[1em] text-Gray-700 md:mt-[18px] md:text-xl'>
          {subtitle}
        </p>
      </div>

      <div className='destinationRowCTM-child flex gap-[18px] overflow-x-auto scroll-smooth px-6 md:gap-8 md:px-[45px]'>
        {children}
      </div>
    </section>;
};
export default DestinationRow;